// extracted by mini-css-extract-plugin
export default {"propertyDetailsHeader":"style-module--propertyDetailsHeader--06fb5","options":"style-module--options--ae275"};